import PropTypes from 'prop-types';

import { Box } from '@hivebrite/design-system/Box';
import { Loader } from '@hivebrite/design-system/Loader';

import Grid, { Col, Row } from 'hb-react/shared/components/DesignSystem/Grid';
import ErrorBoundary from 'hb-react/shared/components/ErrorBoundary';
import useOutboxedFontTheme from 'hb-react/shared/hooks/theme/useOutboxedFontTheme';
import useQueryOnce from 'hb-react/shared/hooks/useQueryOnce';
import { axiosInstance as axios } from 'hb-react/shared/utils/axios';
import ThemeProvider from 'hb-react/style/ThemeProvider';

import EventCard from '../EventsIndexContainer/components/EventCard';

const queryHighlightedEvents = (id) =>
  axios
    .get(Routes.network_event_highlighted_events_path(id))
    .then(({ data }) => data.events);

const HighlightedEvents = ({
  eventId,
  headline,
  onEventCardClick,
  timezoneConfiguration,
}) => {
  const outboxedFontTheme = useOutboxedFontTheme();
  const header = headline || s__('Events|Highlighted Events');

  const { isLoading, data: highlightedEvents = [] } = useQueryOnce({
    queryKey: ['highlighted-events', eventId],
    queryFn: () => queryHighlightedEvents(eventId),
  });

  if (isLoading) {
    return <Loader size={24} />;
  }

  if (highlightedEvents.length === 0) {
    return null;
  }

  return (
    <>
      <ThemeProvider
        theme={outboxedFontTheme.themeName}
        fontBrightness={outboxedFontTheme.fontBrightness}
      >
        <Box ml={{ s: 6, m: 0, l: 0, xl: 0 }} mt={12} font="h2-semibold">
          {header} ({highlightedEvents.length})
        </Box>
      </ThemeProvider>
      <Grid ml={{ s: 6, m: 0, l: 0, xl: 0 }}>
        <Row
          height="auto"
          flexDirection={{
            l: 'row',
            m: 'row',
            s: 'column-reverse',
          }}
          mt={4}
        >
          {highlightedEvents.map((event) => (
            <Col key={event.id} width={({ numCols }) => 4 / numCols}>
              <EventCard
                event={event}
                key={event.id}
                onClick={onEventCardClick}
                timezoneConfiguration={timezoneConfiguration}
              />
            </Col>
          ))}
        </Row>
      </Grid>
    </>
  );
};

const HighlightedEventsWrapper = (props) => (
  <ErrorBoundary>
    <HighlightedEvents {...props} />
  </ErrorBoundary>
);

HighlightedEvents.propTypes = {
  eventId: PropTypes.number.isRequired,
  headline: PropTypes.string,
  onEventCardClick: PropTypes.func,
};

export default HighlightedEventsWrapper;
